import { Store } from '@ngrx/store';
import { fetchUserWatchlists, removeWatchlistItemError, removeWatchlistSecurityObject, setWatchlistsFetchFailure, setWatchlistsFetchSuccess, } from 'WatchlistApp/ts/features/add-to-watchlist-modal/state/add-to-watchlist-modal.actions';
import { ADD_TO_WATCHLIST_STATE_SLICE_KEY } from 'WatchlistApp/ts/features/add-to-watchlist-modal/state/add-to-watchlist-modal.reducer';
import { getGroupedWatchlists, isFinishedFetchingWatchlists, } from 'WatchlistApp/ts/features/add-to-watchlist-modal/state/add-to-watchlist-modal.selectors';
import { DASHBOARD_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { WatchlistsService } from 'WatchlistApp/ts/services/watchlists.service';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "WatchlistApp/ts/services/watchlists.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "NewAngular/services/core/urls.service";
import * as i4 from "@ngrx/store";
import * as i5 from "@angular/common";
import * as i6 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i8 from "../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i9 from "../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i10 from "WatchlistApp/ts/features/add-to-watchlist-modal/components/create-watchlist-field-item.component";
import * as i11 from "WatchlistApp/ts/features/add-to-watchlist-modal/components/watchlist-group.component";
function AddToWatchlistModalComponent_ycn_loading_symbol_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 18);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading Watchlists...");
} }
function AddToWatchlistModalComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 20);
    i0.ɵɵelement(2, "ycn-watchlist-group", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 20);
    i0.ɵɵelement(4, "ycn-watchlist-group", 21);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("watchlistGroupType", "containing")("watchlistGroupData", ctx_r0.containingWatchlists);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("watchlistGroupType", "excluding")("watchlistGroupData", ctx_r0.excludingWatchlists);
} }
export class AddToWatchlistModalComponent {
    constructor(watchlistsService, featureService, urlsService, store) {
        this.watchlistsService = watchlistsService;
        this.featureService = featureService;
        this.urlsService = urlsService;
        this.store = store;
        this.mapStateToComponent = (state) => {
            if (state.securityObject && !this.modalOpen) {
                this.openModal();
            }
            this.loading = !isFinishedFetchingWatchlists(state);
            this.error = state.watchlistItemError;
            const { containingWatchlists, excludingWatchlists } = getGroupedWatchlists(state);
            this.containingWatchlists = containingWatchlists;
            this.excludingWatchlists = excludingWatchlists;
        };
        this.storeSubscription = this.store
            .select(ADD_TO_WATCHLIST_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
        this.modalOpen = false;
        this.loading = false;
        this.watchlistListPageUrl = `${this.urlsService.WATCHLISTS.WATCHLIST_LIST_PAGE}`;
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    // if user has dashboard_feature will open modal. Otherwise, will open featureNeededComponent
    openModal() {
        if (this.featureService.userHasFeatures([DASHBOARD_FEATURE])) {
            this.store.dispatch(fetchUserWatchlists());
            this.watchlistsService.getAddToWatchlistMenu().subscribe({
                next: (data) => {
                    this.store.dispatch(setWatchlistsFetchSuccess({ itemsMap: data }));
                },
                error: () => {
                    this.store.dispatch(setWatchlistsFetchFailure());
                },
            });
            this.modalOpen = true;
        }
        else {
            this.featureNeededComponent.openModal(DASHBOARD_FEATURE);
        }
    }
    closeModal() {
        this.store.dispatch(removeWatchlistItemError());
        this.store.dispatch(removeWatchlistSecurityObject());
        this.modalOpen = false;
    }
}
AddToWatchlistModalComponent.ɵfac = function AddToWatchlistModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AddToWatchlistModalComponent)(i0.ɵɵdirectiveInject(i1.WatchlistsService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.UrlsService), i0.ɵɵdirectiveInject(i4.Store)); };
AddToWatchlistModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AddToWatchlistModalComponent, selectors: [["ycn-add-to-watchlist-modal"]], viewQuery: function AddToWatchlistModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(FeatureNeededComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.featureNeededComponent = _t.first);
    } }, standalone: false, decls: 23, vars: 7, consts: [[3, "closeModalHandler", "open"], [1, "modal-header", "user-select-none"], [1, "modal-title", 3, "textContent"], [1, "modal-header-actions"], [1, "modal-header-action"], [1, "btn", "btn-modal-header", 3, "href"], ["data-test-id", "add-to-watchlist-modal-header-close", "aria-label", "Close", 1, "close", "btn", "btn-modal-header", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "modal-body"], [1, "modal-section", "pb-20"], [1, "text-red", 3, "textContent"], [1, "mb-2"], [1, "divider-horizontal"], [1, "mb-1"], [1, "form-label", "form-label-thin"], [3, "loaderMessage", 4, "ngIf"], ["class", "linked-lists", 4, "ngIf"], [1, "modal-footer"], [3, "loaderMessage"], [1, "linked-lists"], [1, "linked-list", "linked-list-text-overflow"], [3, "watchlistGroupType", "watchlistGroupData"]], template: function AddToWatchlistModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function AddToWatchlistModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "a", 5);
        i0.ɵɵtext(6, " View Watchlist Manager ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 4)(8, "div", 6);
        i0.ɵɵlistener("click", function AddToWatchlistModalComponent_Template_div_click_8_listener() { return ctx.closeModal(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(9, "svg", 7);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(10, "div", 8)(11, "div", 9);
        i0.ɵɵelement(12, "ycn-create-watchlist-field-item")(13, "div", 10);
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵelement(15, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 13)(17, "div", 14);
        i0.ɵɵtext(18, "or Select a Watchlist:");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(19, AddToWatchlistModalComponent_ycn_loading_symbol_19_Template, 1, 1, "ycn-loading-symbol", 15)(20, AddToWatchlistModalComponent_div_20_Template, 5, 4, "div", 16);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(21, "div", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(22, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("textContent", "Add To Watchlist");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("href", ctx.watchlistListPageUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("name", "icon-close");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("textContent", ctx.error);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
    } }, dependencies: [i5.NgIf, i6.IconDirective, i7.ModalBaseComponent, i8.FeatureNeededComponent, i9.LoadingSymbolComponent, i10.CreateWatchlistFieldItemComponent, i11.WatchlistGroupComponent], encapsulation: 2 });
